<div class="header-container">
  <mat-form-field appearance="outline" class="search-field">
    <input matInput [(ngModel)]="searchKeyword" placeholder="Search items" (input)="onSearch()">
    <mat-progress-spinner *ngIf="searchingKeywords" matSuffix diameter="20" mode="indeterminate"
      class="search-spinner">
    </mat-progress-spinner>
    <button mat-icon-button matSuffix *ngIf="searchKeyword" (click)="clearSearch()">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>
  <button mat-raised-button color="primary" class="add-user-btn" (click)="openAddUserModal()">
    <mat-icon>person_add</mat-icon>
    Add User
  </button>
</div>

<div class="user-table-container">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort [matSortDisableClear]="true"
  (matSortChange)="announceSortChange($event)">

    <!-- Name Column -->
    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort name">
        Name
      </th>
      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>

    <!-- Email Column -->
    <ng-container matColumnDef="Email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by email">
        E-mail
      </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <!-- Initials Column -->
    <ng-container matColumnDef="Initials">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by initials">
        Initials
      </th>
      <td mat-cell *matCellDef="let element"> {{element.initials}} </td>
    </ng-container>

    <!-- Role Column -->
    <ng-container matColumnDef="Role">
      <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by role">
        Role
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!element.isEditing">
          {{element.role}}
        </ng-container>
        <ng-container *ngIf="element.isEditing">
          <mat-form-field>
            <mat-label>Select role</mat-label>
            <mat-select [(ngModel)]="element.role" name="role" required>
              <mat-option *ngFor="let role of roles" [value]="role">{{role}}</mat-option>
            </mat-select>
            <mat-error *ngIf="!element.role">
              Role is required
            </mat-error>
          </mat-form-field>
        </ng-container>
      </td>
    </ng-container>

    <!-- Companies Column -->
    <ng-container matColumnDef="Companies">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Companies
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!element.isEditing; else editTemplate">
          <!-- Display only first 3 companies followed by ellipsis if there are more -->
          <span matTooltip="{{ element.companies.join(', ') }}" matTooltipPosition="above">
            {{ (element.companies | slice:0:3).join(', ') }}<span *ngIf="element.companies.length > 3">...</span>
          </span>
        </ng-container>
        <ng-template #editTemplate>
          <mat-form-field>
            <mat-label>Companies</mat-label>
            <mat-select [formControl]="companies" multiple [(ngModel)]="element.companies" required>
              <mat-select-trigger>
                {{ companies.value?.[0] || '' }}
                <span *ngIf="(companies.value?.length || 0) > 1" class="example-additional-selection">
                  (+{{(companies.value?.length || 0) - 1}} {{companies.value?.length === 2 ? 'other' : 'others'}})
                </span>
              </mat-select-trigger>
              <mat-option *ngFor="let company of companiesList" [value]="company">{{company}}</mat-option>
            </mat-select>
            <mat-error *ngIf="!element.companies || element.companies.length === 0">
              Select at least one company
            </mat-error>
          </mat-form-field>
        </ng-template>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.isEditing">
          <div class="button-container-users">
            <button mat-icon-button class="save-button-users"
              (click)="saveUser(element)"
              [disabled]="element.isSaving || element.isLoadingGroupAccountName || element.isLoadingGroupType || !element.role || !element.companies?.length" matTooltip="Save">
              <ng-container *ngIf="!element.isSaving">
                <mat-icon fontSet="material-icons-outlined">save</mat-icon>              
              </ng-container>
              <ng-container *ngIf="element.isSaving">
                <mat-spinner diameter="20"></mat-spinner>
              </ng-container>
            </button>
            <button mat-icon-button class="discard-button-users" (click)="discardChanges(element)" [disabled]="element.isSaving" matTooltip="Cancel">
              <mat-icon fontSet="material-icons-outlined">cancel</mat-icon>
            </button>
          </div>
        </ng-container>
        <ng-container *ngIf="!element.isEditing">
          <div class="button-container-users">
            <button mat-icon-button class="edit-button-users" (click)="editElement(element)" [disabled]="element.isSaving" matTooltip="Edit">
              <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
            </button>
            <button mat-icon-button (click)="deleteUser(element)" [disabled]="element.isSaving" matTooltip="Delete">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
</div>
<div class="loading-overlay" *ngIf="isLoading">
  <mat-spinner diameter="50"></mat-spinner>
</div>
@if (!isLoading && page.length > 10) {
  <mat-paginator [length]="page.length" [pageSize]="page.pageSize" [pageIndex]="page.pageIndex"
    [pageSizeOptions]="[10, 50, 100]" (page)="pageChanged($event)" aria-label="Select page" [showFirstLastButtons]="true">
  </mat-paginator>
}
